import { Component, computed, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RouteReplayDataService } from '../../services/route-replay-data.service';
import { RouteReplayResponse, Vehicle, RouteData } from '../../models/route-replay-response.model';

@Component({
  selector: 'route-side-bar',
  templateUrl: './side-bar.component.html',
  styleUrl: './side-bar.component.scss'
})
export class SideBarComponent implements OnInit {
  routeData: RouteReplayResponse | null = null;
  multiRouteData: RouteData[] = [];
  isMultiRoute: boolean = false;
  routeName: string = '';
  selectedVehicles: Vehicle[] = [];
  imgSrc: string = '';
  source = computed(() => this.routeReplayDataService.source());
  buid = computed(() => this.routeReplayDataService.buid());
  
  // Date and shift info
  selectedDate: string = '';
  selectedShift: string = '';

  constructor(
    private router: Router,
    private routeReplayDataService: RouteReplayDataService,
    private activatedRoute: ActivatedRoute
  ) {}

  ngOnInit(): void {
    // Get date and shift from query parameters
    const queryParams = this.activatedRoute.snapshot.queryParams;
    this.selectedDate = queryParams['date'] || '';
    this.selectedShift = queryParams['shift'] || '';
    
    // Always subscribe to multi-route data (works for single route too)
    this.routeReplayDataService.multiRouteData$.subscribe(routes => {
      if (routes && routes.length > 0) {
        this.multiRouteData = routes;
        this.isMultiRoute = true; // Always use multi-route UI
        this.routeName = routes.length === 1 
          ? `${routes[0].startLocation} → ${routes[0].endLocation}`
          : `${routes.length} Routes Selected`;
      }
    });
  }

  onBackClick(): void {
    this.router.navigate(
      ['/route-replay'],
      {
        queryParams: {
          source: this.source() || '',
          buid: this.buid() || ''
        }
      }
    );
  }

  onVehicleSelectionChange(vehicles: Vehicle[]): void {
    this.selectedVehicles = vehicles;
    // Emit to map component to plot selected vehicles
    this.routeReplayDataService.updateSelectedVehicles(vehicles);
  }

  toggleRouteExpansion(route: RouteData): void {
    route.isExpanded = !route.isExpanded;
  }

  onMultiRouteVehicleSelectionChange(routeIndex: number, vehicles: Vehicle[]): void {
    // Collect all selected vehicles from all routes
    const allSelectedVehicles: Vehicle[] = [];
    
    this.multiRouteData.forEach((route, index) => {
      if (index === routeIndex) {
        // Update vehicles for this route
        route.vehicles.forEach(v => {
          const isSelected = vehicles.some(sv => sv.etsVehicle.guId === v.etsVehicle.guId);
          v.selected = isSelected;
          if (isSelected) {
            allSelectedVehicles.push(v);
          }
        });
      } else {
        // Keep existing selections from other routes
        route.vehicles.forEach(v => {
          if (v.selected) {
            allSelectedVehicles.push(v);
          }
        });
      }
    });
    
    this.selectedVehicles = allSelectedVehicles;
    this.routeReplayDataService.updateSelectedVehicles(allSelectedVehicles);
  }
}
